import { render } from "./CitationText.vue?vue&type=template&id=2a61ae22&scoped=true"
import script from "./CitationText.vue?vue&type=script&lang=js"
export * from "./CitationText.vue?vue&type=script&lang=js"

import "./CitationText.vue?vue&type=style&index=0&id=2a61ae22&scoped=true&lang=css"
import "./CitationText.vue?vue&type=style&index=1&id=2a61ae22&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a61ae22"]])

export default __exports__